import { render, staticRenderFns } from "./ResAccount.vue?vue&type=template&id=81ecfd86&scoped=true"
import script from "./ResAccount.vue?vue&type=script&lang=js"
export * from "./ResAccount.vue?vue&type=script&lang=js"
import style0 from "./ResAccount.vue?vue&type=style&index=0&id=81ecfd86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ecfd86",
  null
  
)

export default component.exports